import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  FreemiumBannerMobileDefinition,
  FreemiumBannerMobilePlatformProps,
} from '../FreemiumBannerMobile.types';

export const props = withCompInfo<
  FreemiumBannerMobilePlatformProps,
  FreemiumBannerMobileDefinition
>()(['direction', 'metaSiteId'], ({ direction, metaSiteId }) => {
  return {
    useOverlay: false,
    direction,
    href: `https://apps.wix.com/place-invites/join-lp/${metaSiteId}?ref=free_banner`,
    classNames: [direction],
    shouldReportBi: true,
  };
});

export default createComponentMapperModel({ props });
